import palette from 'theme/palette';
import { USER_FEED_ID, USER_FEED_NAME } from 'app-constants';

import { UserFeedFollowGroupFragment } from 'api';

import useCurrentUser from './useCurrentUser';

export default () => {
  const currentUser = useCurrentUser();

  function getTimelineFeed(): UserFeedFollowGroupFragment {
    return {
      id: currentUser.id,
      title: USER_FEED_NAME,
      color_map: {
        hex: palette.blue,
      },
      icon_map: {
        file_key: null,
        bucket: null,
      },
    };
  }

  function getTimelineGroup(): UserFeedFollowGroupFragment {
    return {
      id: USER_FEED_ID,
      title: USER_FEED_NAME,
      color_map: {
        hex: palette.blue,
      },
      icon_map: {
        file_key: null,
        bucket: null,
      },
    };
  }

  return {
    timelineFeed: getTimelineFeed(),
    timelineGroup: getTimelineGroup(),
  };
};
